export const getToken = state => state.currentUser.token;
export const getRefreshToken = state => state.currentUser.refreshToken;
export const getSid = state => state.currentUser.sid;
export const getIsLoggedIn = state => state.currentUser.isLoggedIn;
export const getEmail = state => state.currentUser.email;
export const getWidth = state => state.currentUser.width;
export const getBalance = state => state.currentUser.balance;
export const getCategory = state => state.currentUser.category;
export const getFilterCategory = state => state.currentUser.filterCategory;
